import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapModule } from '../map/map.module';
import { MapLocContainerComponent } from './components/map-loc-container.component';
import { IconStatusModule } from '@ess-front/shared';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [MapLocContainerComponent],
  imports: [CommonModule, MapModule, IconStatusModule, MatButtonModule],
  exports: [MapLocContainerComponent],
})
export class MapLocContainerModule {}
